import React from 'react';
import { LegalLayout } from '../components/legal/LegalLayout';

const SECTIONS = [
  {
    heading: 'Data We Collect',
    body: [
      'Account information you provide when you register or are invited: name, email address, phone number, role and company or brand name.',
      'Creator profile information: social media handles, public follower and engagement statistics, content categories, location, rate cards and media kits.',
      'Campaign information: briefs, shortlists, mandates, deliverables, draft and live content links, shipping addresses for product dispatch, costs and invoices.',
      'Communications: messages exchanged with creators through WhatsApp and email as part of campaign coordination.',
      'Technical data: log data, device and browser information, and cookies required to keep you signed in.',
    ],
  },
  {
    heading: 'How We Use Data',
    body: [
      'To operate the Vyvre platform: matching brands with creators, planning and running campaigns, coordinating logistics, tracking deliverables and producing reports.',
      'To send operational messages such as campaign invitations, mandate questions, cost confirmations and status updates via WhatsApp or email.',
      'To create and update campaign tracking spreadsheets in Google Sheets on behalf of our team and to share client-facing views with the relevant brand.',
      'To improve the platform, prevent abuse and comply with legal obligations. We do not sell your personal data.',
    ],
  },
  {
    heading: 'Google User Data',
    body: [
      'Vyvre requests access to Google Sheets and Google Drive solely to create and update campaign tracking spreadsheets inside a designated Vyvre folder. We do not read, modify or share any other files in your Google account.',
      "Vyvre's use and transfer of information received from Google APIs adheres to the Google API Services User Data Policy, including the Limited Use requirements.",
    ],
  },
  {
    heading: 'Data Storage',
    body: [
      'Data is stored on secure cloud infrastructure with encryption in transit (HTTPS). Access is restricted by role, so brands, agencies, managers and creators only see the data relevant to them.',
      'Internal campaign sheets containing costs and contact details are kept private; client sheets are shared view-only with the relevant brand.',
      'We retain data for as long as your account is active or as needed to fulfil campaign, accounting and legal requirements. You may request deletion of your data at any time.',
    ],
  },
  {
    heading: 'Contact Us',
    body: [
      'For questions about this policy, or to access, correct or delete your data, email us at hello@vyvre.in.',
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      testid="privacy-page"
      title="Privacy Policy — Vyvre"
      updated="October 2026"
      intro="This policy explains what information Vyvre collects, how we use it and how we keep it safe when you use our creator intelligence platform."
      sections={SECTIONS}
    />
  );
}
